import React from 'react';
import './App.css';
import "animate.css/animate.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from './router/index'
import { Provider } from 'react-redux';
import Store from './redux/configureStore'
function App() {
  
  return (
    <Provider store={Store}>
      <Router>
        <AppRoutes />
      </Router>
    </Provider>
  );
}

export default App;
